import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, Typography, ButtonBase } from '@material-ui/core/';
import styles from 'styles/components/rgpdDialog.module.scss';

function RgpdDialog(props) {
    const { handleCloseRgpdDialog } = props;
    return (
        <div className={styles.root}>
            <AppBar className={styles.header}>
                <Toolbar className={styles.toolBar}>
                    <Typography variant="h6" color="inherit" className={styles.grow}>
                        Em construcao - En construction - Work in progress
                    </Typography>
                    <div className={styles.buttonContainer}>
                        <ButtonBase
                            className={styles.cssRoot}
                            onClick={handleCloseRgpdDialog}
                        >
                            Fechar - Fermer - Close
                        </ButtonBase>
                    </div>
                </Toolbar>
            </AppBar>
        </div>
    );
}

RgpdDialog.propTypes = {
    handleCloseRgpdDialog: PropTypes.func.isRequired,
};

export default RgpdDialog;
